import { render, staticRenderFns } from "./GateOtherDamages.vue?vue&type=template&id=bc90bde8&scoped=true"
import script from "./GateOtherDamages.vue?vue&type=script&lang=ts"
export * from "./GateOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc90bde8",
  null
  
)

export default component.exports